<template>
	<div>
		<LaptopDocuments v-if="isLaptop" :isLaptop="isLaptop" />
		<MobileDocuments v-else :isLaptop="isLaptop" />
	</div>
</template>

<script>
import LaptopDocuments from "../CandidateDocuments/CandidateDocsList.vue";
import MobileDocuments from "../../components/MobileComponents/Documents/Document.vue";
export default {
	name: "Dashboard",
	components: {
		LaptopDocuments,
		MobileDocuments,
	},
	data() {
		return {
			isLaptop: true,
		};
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
		console.log("mount");
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
			console.log(this.isLaptop); // Adjust the threshold value as needed
		},
	},
};
</script>

<style></style>
